import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore'; 

import companyLogo from '../../assets/payment.png'; 
import signatureMorshed from '../../assets/morshed.png'; 
import signatureAnis from '../../assets/anis.png';     

const formatCurrency = (num) => {
  if (typeof num !== 'number') { num = parseFloat(num || 0); }
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

function numberToWords(num) {
    const a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
    const b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
    const inWordsBDTInternal = (n) => {
        let str = '';
        if (n > 9999999) { str += inWordsBDTInternal(Math.floor(n / 10000000)); str += 'Crore '; n %= 10000000; }
        if (n > 99999) { str += inWordsBDTInternal(Math.floor(n / 100000)); str += 'Lakh '; n %= 100000; }
        if (n > 999) { str += inWordsBDTInternal(Math.floor(n / 1000)); str += 'Thousand '; n %= 1000; }
        if (n > 99) { str += inWordsBDTInternal(Math.floor(n / 100)); str += 'Hundred '; n %= 100; }
        if (n > 19) { str += b[Math.floor(n / 10)] + ' ' + a[n % 10]; } else { str += a[n]; }
        return str; 
    };
    const taka = Math.round(parseFloat(num || 0));
    if (taka === 0) return 'BDT ZERO TAKA ONLY';
    let takaWords = inWordsBDTInternal(taka).trim(); 
    let result = 'BDT ' + takaWords + ' Taka Only'; 
    return result.replace(/\s+/g, ' ').toUpperCase();
}

const InvoiceReceipts = () => {
    const { invoiceId } = useParams(); 
    const navigate = useNavigate();
    const [receipts, setReceipts] = useState([]);
    const [liveInvoice, setLiveInvoice] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            if (!invoiceId) return;
            setLoading(true);
            try {
                // ১. ইনভয়েস ডেটা আনা
                const invoiceRef = doc(db, "invoices", invoiceId);
                const invoiceSnap = await getDoc(invoiceRef);
                
                if (invoiceSnap.exists()) {
                    const invoiceData = invoiceSnap.data();
                    setLiveInvoice(invoiceData);

                    // ২. ইনভয়েসের paidEntries থেকে সব পেমেন্ট আইডি বের করা
                    if (invoiceData.paidEntries && invoiceData.paidEntries.length > 0) {
                        const paymentPromises = invoiceData.paidEntries.map(entry => 
                            getDoc(doc(db, "payments", entry.paymentDocId))
                        );
                        
                        const paymentSnapshots = await Promise.all(paymentPromises);
                        
                        // পেমেন্টগুলো ফিল্টার করে সাজানো
                        const loadedReceipts = paymentSnapshots
                            .filter(snap => snap.exists())
                            .map(snap => ({ id: snap.id, ...snap.data() }));
                        
                        setReceipts(loadedReceipts);
                    } else {
                        setReceipts([]);
                    }
                } else {
                    console.log("Invoice not found!");
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
            setLoading(false);
        };
        fetchData();
    }, [invoiceId]);

    if (loading) return <p style={{textAlign:'center', marginTop:'20px'}}>Loading receipts...</p>;
    if (!liveInvoice) return <div style={{textAlign:'center', marginTop:'20px'}}><p>Invoice not found.</p><button onClick={() => navigate('/dashboard/full-report')}>Back to Report</button></div>;
    if (receipts.length === 0) return <div style={{textAlign:'center', marginTop:'20px'}}><p>No receipts found for this invoice.</p><button onClick={() => navigate('/dashboard/full-report')}>Back to Report</button></div>;

    return (
        <div className="view-invoice-container">
            {/* অ্যাকশন বাটন - ব্যাক বাটন Full Report এ নিয়ে যাবে */}
            <div className="invoice-actions no-print">
                <button onClick={() => navigate('/dashboard/full-report')}>Back to Full Report</button>
                <button onClick={() => window.print()}>Print All Receipts</button>
            </div>

            {/* লুপ করে সব রিসিপ্ট দেখানো হচ্ছে */}
            {receipts.map((receipt, rIndex) => {
                 const paymentEntries = receipt.paymentEntries || [{
                    id: 1, amount: receipt.amount, method: receipt.method, remarks: receipt.chequeNo || receipt.remarks 
                }];
                const totalAmount = receipt.totalAmount || receipt.amount;
            
                const displayDate = receipt.date 
                    ? receipt.date 
                    : (receipt.paymentTimestamp ? new Date(receipt.paymentTimestamp.toDate()).toLocaleDateString('en-GB') : 'N/A');

                return (
                    <div key={receipt.id} className="invoice-paper" style={{marginBottom: '30px', pageBreakAfter: 'always', minHeight: 'auto'}}>
                        <div className="invoice-header">
                            <h1>TWS AIR INTERNATIONAL</h1>
                            <p>10/3/7 Toyenbee Circular Road, Motijheel C/A, Dhaka-1000, BANGLADESH.</p>
                            <h2 className="receipt-title">MONEY RECEIPT</h2>
                        </div>
                        
                        <div className="customer-details">
                            <div>
                                <p><strong>Received From:</strong> {receipt.companyName}</p>
                                <p><strong>Address:</strong> {receipt.address}</p>
                            </div>
                            <div>
                                <p><strong>Receipt No:</strong> <span style={{color: 'red', fontWeight: 'bold'}}>{receipt.receiptNo}</span></p>
                                <p><strong>Receipt Date:</strong> {displayDate}</p>
                            </div>
                        </div>

                        <table className="invoice-items-table">
                            <thead>
                                <tr>
                                    <th>Details</th>
                                    <th>Amount (BDT)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paymentEntries.map((entry, index) => (
                                    <tr key={index}>
                                        <td style={{textAlign: 'left', padding: '10px'}}>
                                            Payment Method: <strong>{entry.method}</strong>
                                            {(entry.remarks) && (
                                                <p style={{fontSize: '11px', color: '#555', margin: '5px 0 0 0'}}>
                                                    <em>Remarks: {entry.remarks}</em>
                                                </p>
                                            )}
                                        </td>
                                        <td style={{textAlign: 'right', padding: '10px', fontWeight: 'bold', fontSize: '14px'}}>
                                            {formatCurrency(entry.amount)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="invoice-summary-view" style={{marginTop: '30px'}}>
                            <div className="summary-left">
                                <div className="in-word-container">
                                    <strong>IN WORD: </strong>
                                    <span>{numberToWords(totalAmount)}</span>
                                </div>
                            </div>
                            <div className="summary-right" style={{width: '40%'}}>
                                <p className="final-total-view">
                                    <span>Total Received</span> <span>{formatCurrency(totalAmount)}</span>
                                </p>
                                
                                <p className="final-total-view amount-due-view">
                                    <span>AMOUNT DUE @ {displayDate}</span> 
                                    <span>{formatCurrency(liveInvoice.finalTotalBdt)}</span>
                                </p>
                            </div>
                        </div>
                        
                        <div className="receipt-signature-area">
                            <div className="signature-box">
                                <p>-----------------------------</p>
                                <p><strong>Receiver's Signature</strong></p>
                            </div>
                            
                            <div className="signature-box seal-box">
                                <img src={companyLogo} alt="Company Logo" className="receipt-company-logo" />
                            </div>
                            
                            <div className="signature-box authorized-signature-box">
                                {receipt.authorizedBy === 'Anis Ahmed' && (
                                    <img src={signatureAnis} alt="Anis Ahmed Signature" className="receipt-signature-img" />
                                )}
                                {receipt.authorizedBy === 'MD. Morshed' && (
                                    <img src={signatureMorshed} alt="MD. Morshed Signature" className="receipt-signature-img" />
                                )}
                                
                                <p className="signature-line">-----------------------------</p>
                                <p><strong>Authorized Signature</strong></p>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default InvoiceReceipts;